<template>
  <el-main :style="{height:height+'px'}">
    <div class="Scroll_content" >
      <div>
        <div v-if="list.length != 0">
          <div class="list_content" v-for="(item,index) in list" :key="index">
            <div class="left_content">
                <div class="time_text">
                  <div class="title_content">{{item.subjects_title}}</div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="timecontent">
                    {{item.next_start_time}} - {{item.next_end_time}}
                    <button :class="item.status==0?'willStartIn':item.status == 1?'progress':item.status == 2?'completed':'btnNone'">
                      <span class="dot"></span>
                      {{item.status == 0?$t('new_test2.Not_Started'):(item.status==1?$t('new_test2.In_progress'):(item.status==2?$t('new_test2.Completed'):''))}}
                    </button>
                  </div>
                </div>
              </div>
              <div class="content_box">

                <div class="title_content_bom">
                  <div class="dom">
                    <p>{{$t('new_test2.Level')}}</p> :&nbsp;&nbsp;<span>{{item.level_title}}</span></div>
                  <div class="dom">
                    <p>{{$t('test2.meet')}}</p> :&nbsp;&nbsp;<span>{{item.meet}}</span></div>
                  <div class="dom">
                    <p>{{$t('test2.Next_class')}}</p> :&nbsp;&nbsp;<span>{{item.next_start_date}}</span></div>
                </div>
                <div class="send_botton">
                  <div class="bunmer presentation_preview" v-if="item && item.courseware_url"
                    @click="enterClassFile(item)">{{ $t('main.PresentationPreview') }}</div>
                </div>
              </div>
          </div>
        </div>

        <NoScheduleEmpty v-else />


        <div class="dian"></div>
      </div>

    </div>
  </el-main>

</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'
  import NoScheduleEmpty from './NoScheduleEmpty'

  export default {
    components: {
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header,
      NoScheduleEmpty
    },
    data () {
      return {
        height:100,
        tableMaxHeight:null,
        list:[],
        timing: null,
        data: [],
        childData: [],
        interval: null,
        activeTitle: 'schedule', /* calendar */
        timeRang: Array.apply(null, Array(2)).map(() => ''), // 日期范围
        searchStudentSn: '',
        scheduleData: [],
        courseData: [],
        balanceData: {},
        lessonData: [],
        now_status: '',
        pageNum: 1,
        total: 0,
        pagesize: 10
      }
    },
    created () {
      let height = document.body.offsetHeight-104;
      this.height = height
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/onboarding'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.getCourse();
      this.timing = setInterval(() => {
        this.format_time()
        this.$forceUpdate()
      }, 1000)
    },
    beforeDestroy () {
      if (this.timing) {
        clearInterval(this.timing)
      }
    },
    methods: {
      enterClassFile (data) {
        window.open(data.courseware_url)
      },
      enterClassRoom (dataJson) {
        const studentSn = dataJson.student_sn || getStore(keys.userProfile).last_student_sn
        this.$http.post('/api/SectionIsIn', {
          lesson_sn: dataJson.lesson_sn,
          student_sn: studentSn
        }).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.is_class) {
              this.$http.post('/api/joinLive', {
                lesson_sn: dataJson.lesson_sn,
                student_sn: studentSn
              }).then((res) => {
                window.open(res.data.data.url)
              }).catch((error) => {
                console.log(error)
              })
            } else {
              this.$message({
                message: res.data.data.message,
                type: 'warning'
              })
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      format_time () {
        if (!Array.isArray(this.list)) {
          return
        }
        for (let i = 0; i < this.list.length; i++) {
          const item = this.list[i]
          const startAt = item.start_at || item.next_start_at
          if (!startAt) {
            item.enterStatus = item.status == 1
            continue
          }
          const beg = this.utils.formatDate(startAt).getTime()
          const now = new Date().getTime()
          const begTime = beg - now
          item.enterStatus = begTime < 300000
        }
      },
      getCourse () {
        let children_id = getStore(keys.userProfile);
        // children_id.last_student_sn
        this.$http.post('/api/myProgram?student_sn=' + children_id.last_student_sn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            this.list = res.data.data
            this.format_time()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
    },
    mounted () {


    },
  }
</script>
<style lang="less" scoped>
.el-main {
  overflow: inherit;
}

.Scroll_content {
  height: 400px;

  .list_content {
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.09);
    box-shadow: 0px 4px 26.64px rgba(0, 0, 0, 0.09);
    border-radius: 9px;
    box-sizing: border-box;
    margin-top: 17px;

    .left_content {
      font-family: Sofia Pro;
      font-style: normal;
      display: flex;
      justify-content: space-between;

      .time_text {
        font-size: 20px;
        margin: 16px 0 20px 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex: 1;

        .title_content {
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          color: #000000;
          margin-bottom: 0;
        }

        .timecontent {
          display: flex;
          align-items: center;

          button {
            margin-left: 30px;
          }
        }
      }
    }

    .content_box {
      border: 0px solid red;
      margin: 0px 16px 16px 16px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title_content_bom {
        display: flex;

        .dom {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          p {
            font-size: 16px;
            color: #000000;
            min-width: 40px;
          }

          span {
            font-size: 16px;
            color: #6B6B6B;
            display: block;
            min-width: 162px;
            margin-top: 0;
          }
        }
      }

      .send_botton {
        display: flex;
        margin-left: 30px;
        min-width: 100px;
        .bunmer {
          background: #B50604;
          border-radius: 8px;
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: bold;
          font-size: 16px;
          line-height: 16px;
          align-items: center;
          text-align: center;
          color: #B50604;
          margin-top: 16px;
          cursor: pointer;
          padding: 10px 16px;
        }
      }
    }
  }
}

.bunmers {
  padding: 10px 16px;
  height: 36px;
  background: #C9C9C9;
  border-radius: 8px;
  font-family: Sofia Pro;
  font-style: normal;
  font-size: 16px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  cursor: pointer;
  box-sizing: border-box;
}

.presentation_preview {
  margin-right: 24px;
  background-color: #fff !important;
  border: 2px solid #b50604 !important;
  color: #b50604 !important;
  height: 36px !important;
  box-sizing: border-box;
}

.title_older {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #000000;
  margin-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ClassEnrolled.vue